import React from "react";
import SetupCard from "./SetupCard";
import { setupData } from "./setupData";
import setup_icon from "../../../assets/home/setup.svg";

export default function Setup() {
    return (
        <div className="flex items-start gap-2 xl:gap-[120px] relative justify-center align-center ] ">
            <img src={setup_icon} alt="setup" className="w-full absolute top-0 xl:top-[0px] xl:h-[360px]" />
            <div className="inline-flex items-start gap-2 xl:gap-[110px] relative flex-[0_0_auto] top-0 xl:top-[110px] ">
                {setupData.map((item, index) => (
                    <SetupCard key={index} index={index} {...item} />
                ))}
            </div>
        </div>
    );
}
